<script lang="ts" setup>
import {breakpointsTailwind, useBreakpoints} from '@vueuse/core'
import {IconRectangleDots} from "~/components/ui/icons";

const props = defineProps({
  useRectangleIcon: {
    type: Boolean,
    default: false,
  },
  isPostIcon: {
    type: Boolean,
    default: false,
  },
  isMargin: {
    type: Boolean,
    default: false,
  },
  useShareIcon: {
    type: Boolean,
    default: false,
  },
  buttonText: {
    type: String,
    default: null,
  },
});

const breakpoints = useBreakpoints(breakpointsTailwind)
const isDesktop = breakpoints.greater('md')
const openedDropdown = ref(false)
const openedDrawer = ref(false)
const open = () => {
  openedDropdown.value = isDesktop.value
  openedDrawer.value = !isDesktop.value
}
</script>
<template>
  <Button variant="action" class="px-0" v-if="props.isPostIcon" @click="open">
    <IconNavDots/>
  </Button>
  <Button v-else-if="props.buttonText" @click="open">
    {{ props.buttonText }}
  </Button>
  <Button variant="action" class="px-0" v-else-if="props.useShareIcon" @click="open">
    <IconShare/>
  </Button>
  <Button v-else variant="icon" class="" @click="open">
    <IconRectangleDots v-if="props.useRectangleIcon" size="24px"/>
    <IconNavDots v-else size="24px"/>
  </Button>
  <LazyDropdownMenu v-model:open="openedDropdown">
    <DropdownMenuTrigger as-child>
      <div></div>
    </DropdownMenuTrigger>
    <LazyDropdownMenuContent :class="{'mr-2': isMargin}">
      <slot name="content-dropdown"></slot>
    </LazyDropdownMenuContent>
  </LazyDropdownMenu>
  <LazyDrawer v-model:open="openedDrawer">
    <LazyDrawerContent>
      <slot name="content-drawer"></slot>
    </LazyDrawerContent>
  </LazyDrawer>
</template>
